// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { MenuItem } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import i18n from '../../../i18n';
import { currencyConfig } from '../../../config/currency.config';
import { Archive } from '@mui/icons-material';
import React from 'react';
import DialogAbstract from '../../abstract/DialogAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';
import { getModifiedBy } from '../../../utils/cells';

export default class MerchantTerminalGatewaysPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'publicMerchantTerminalGateways';
        this.Server =
            this.props.context.getState().server.publicMerchantTerminalGateways;
        this.MenuDisplayType = 'menu';
        // terminal name, gateway settings, gateway, and gateway account
        this.searchFields = ['currency', 'merchantTerminal.name', 'gateway.name', 'gatewayAccount.name', 'gatewaySettings.templateName'];
        this.hasCustomLogicOnMount = true;

        const defaultHead = [
            {
                id: 'merchantTerminalId',
                label: 'merchantTerminal',
                alignRight: false,
                cell: 'Select',
                show: 'name+merchantTerminalUuid',
                from: 'publicMerchantTerminals',
                object: 'merchantTerminal',
                filterCell: 'Context',
                filterBy: 'publicMerchantTerminals',
                disableEditor: true,
                displayAdd: true,
                displayGrid: true,
                displayOnEditForReadOnly: true
            },
            {
                id: 'gatewayId',
                label: 'gateway',
                alignRight: false,
                cell: 'Select',
                show: 'name',
                from: 'publicGateways',
                object: 'gateway',
                filterCell: 'Context',
                filterBy: 'publicGateways',
                disableEditor: true,
                displayAdd: true,
                displayGrid: true,
                displayOnEditForReadOnly: true
            },
            {
                id: 'gatewayAccountId',
                label: 'gatewayAccount',
                alignRight: false,
                cell: 'Select',
                show: 'name',
                from: 'accountingGatewayAccounts',
                object: 'gatewayAccount',
                disableEditor: true,
                displayAdd: true,
                displayGrid: true,
                displayOnEditForReadOnly: true
            },
            {
                id: 'gatewaySettingsId',
                label: 'gatewaySettings',
                alignRight: false,
                cell: 'Select',
                show: 'templateName',
                from: 'publicGatewaySettings',
                object: 'gatewaySettings',
                // filterOptionsBy: 'gatewayId',
                disableEditor: true,
                displayAdd: true,
                displayGrid: true
            },
            {
                id: 'currency',
                label: 'currency',
                alignRight: false,
                cell: 'Items',
                type: 'currency',
                noTranslate: true,
                items: Object.keys(currencyConfig),
                disableEditor: true,
                displayAdd: true,
                displayGrid: true
            },
            {
                id: 'minAmount',
                label: 'minAmount',
                alignRight: false,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'maxAmount',
                label: 'maxAmount',
                alignRight: false,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'balanceClearTime',
                label: 'balanceClearTime',
                alignRight: false,
                cell: 'Number',
                type: 'number',
                displayGrid: true
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true,
                extraRender: (value, row) => getModifiedBy(row)
            },
            {
                id: 'availableForPayouts',
                label: 'availableForPayouts',
                alignRight: false,
                cell: 'Checkbox',
                type: 'boolean',
                disableEditor: true,
                displayAdd: true,
                displayGrid: true
            },
            {
                id: 'isActive',
                label: 'isActive',
                alignRight: false,
                cell: 'EditableBoolean',
                trueLabel: 'active',
                falseLabel: 'inactive',
                confirmFalseLabel: 'confirmActivateTerminalGateway',
                confirmTrueLabel: 'confirmDeactivateTerminalGateway',
                type: 'boolean',
                displayGrid: true,
                disableEditor: true,
                displayAdd: true
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
    customLogicOnMount() {
        // this.fs.addFilter('isArchived', '!=', true, 'prefilter', true);
        this.fs.clearGroup('prefilterBase')
            .addFilter('isArchived', '!=', true, 'prefilterBase', true);
    }

    loadTemplates = async () => {
        const srv = this.getTemplatesServer();
        if (!srv || typeof srv.getAllFiltered !== 'function') {
            throw new Error(
                'Templates server is not available in context.server'
            );
        }

        const result = await srv.getAllFiltered([], [],);
        if (result && result.error && result.error !== 'OK') {
            const message =
                typeof result.error === 'string'
                    ? result.error
                    : 'Failed to load templates';
            throw new Error(message);
        }

        return { data: Array.isArray(result?.data) ? result.data : [] };
    };

    getTemplatesServer() {
        const server = this.props.context.getState().server;
        return server.publicGatewayTemplates;
    }

    renderCustomMenuItems() {
        const isItemArchived = this.getMenuClickItemValue('isArchived') === true;

        const isAllowedArchive = this.allowedArchive() && !isItemArchived;
        return [
            <MenuItem
                key="showDetails"
                onClick={(event) => this.handleShowDialogDetails(event)}
            >
                <InfoIcon sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.showDetails')}
            </MenuItem>,
            isAllowedArchive && (
                <MenuItem
                    key="archive"
                    onClick={() => this.handleArchiveConfirmDialogOpen()}
                >
                    <Archive sx={{ mr: 2, width: '20px' }} />
                    {i18n.t('common.archive')}
                </MenuItem>
            )
        ];
    }
    handleSaveCell = async (id, isActive) => {
        const res = await this.Server.toggle(id, 'active', isActive);
        if (res.error === 'OK') {
            await this.retrieveData();
            return true;
        }
        this.handleError(res);
        return false;
    };

    renderDialog() {
        const needMR = this.shouldShowModifiedReasonDialog();
        return (
            <DialogAbstract
                dialogOpen={this.state.dialogOpen}
                dialogData={this.state.dialogData}
                role={this.state.currentUserRole}
                error={this.state.dialogError}
                Name={this.Name}
                Head={this.state.head}
                Server={this.Server}
                onSave={(data, mode) =>
                    needMR && mode === 'edit'
                        ? this.handleOpenModifiedReasonDialog(data)
                        : this.handleDialogOnSave(data, mode)
                }
                onClose={() => this.handleDialogOnClose()}
                showTemplateButton={true}
                loadTemplates={this.loadTemplates}
                templateMapping={{
                    gatewayId: { path: ['gateway', 'id'] },
                    gatewayAccountId: { path: ['gatewayAccount', 'id'] },
                    gatewaySettingsId: { path: ['gatewaySetting', 'id'] },
                    currency: { path: ['currency'] }
                }}
            />
        );
    }
}
